/* Publishes the sticky header-group's height as --tuti-header-group-h.

   Horizon's own --header-group-height (computed in layout/theme.liquid)
   is never set on this theme: that script looks for <header-component>,
   which we replaced with sections/tuti-header.liquid, so it returns
   early. Anything that needs to sit directly beneath the pinned header
   group needs this number: the product page's sticky media column takes
   it as its `top` offset, and the bento subtracts it from the viewport.

   #header-group is sticky at top:0 and holds the announcement bar plus
   the header. The header cancels its own height with a negative
   margin-bottom, so the group's layout height is just the announcement
   bar, which is exactly the offset content below it should clear.

   Measured repeatedly rather than once: an early reading taken before
   the stylesheets settle can be wildly too tall (the header section
   briefly occupies flow space), and ResizeObserver is not guaranteed to
   deliver a correcting callback in every environment. A single bad
   reading would otherwise stick and pin the media column hundreds of
   pixels down the page. */
(function () {
  var group = document.getElementById('header-group');
  if (!group) return;

  var root = document.documentElement;

  /* The group is the announcement bar only, so its height is either the
     bar or nothing. Zero is a REAL value, not an artefact: the product
     template renders no announcement bar at all (see
     sections/header-announcements.liquid), leaving the group empty.
     A floor of 8 here meant that page never published the variable and
     fell back to the CSS default, pinning the media column 36px down —
     a gap sitting exactly where the bar used to be.

     The ceiling still earns its place. An early reading taken before
     the stylesheets settle catches the header section while it briefly
     occupies flow space, which is far too tall; that one is discarded
     so the last good reading stands until the next pass. */
  var MIN = 0;
  var MAX = 200;

  var apply = function () {
    var h = Math.round(group.getBoundingClientRect().height);
    if (h < MIN || h > MAX) return;
    root.style.setProperty('--tuti-header-group-h', h + 'px');
  };

  apply();
  requestAnimationFrame(apply);
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(apply).observe(group);
  }

  // Fonts land after first paint and can change the bar's height.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
})();


/* ---- Measured gallery anchors -----------------------------------------
   Two things have to line up with the product gallery from OUTSIDE it:
   the header's "Shop all" link (its right edge sits on the gallery's
   right edge, tablet only) and the shade bubble (its centre sits on the
   swatch grid's centre line).

   Both were first derived in CSS from 100vw minus the page margin and
   the details column. That was wrong in practice: it assumes the grid's
   full-bleed rule and the header's uncapped width apply at the same
   widths, and where they do not the link landed PAST the gallery and
   over the details column. Measuring the rendered boxes cannot drift,
   whatever the layout does at a given width. */
(function () {
  function measure() {
    var gallery = document.querySelector('.tuti-dgal');
    if (!gallery) return;

    var stage = gallery.querySelector('.tuti-dgal__stage') || gallery;
    var stageBox = stage.getBoundingClientRect();
    var galleryBox = gallery.getBoundingClientRect();

    /* Offset from the header inner's CONTENT edge, because that is what
       `left` on an absolutely positioned child resolves against. */
    var inner = document.querySelector('.tuti-header__inner');
    if (inner) {
      var pad = parseFloat(getComputedStyle(inner).paddingLeft) || 0;
      var contentLeft = inner.getBoundingClientRect().left + pad;
      inner.style.setProperty(
        '--tuti-nav-right-offset',
        (stageBox.right - contentLeft) + 'px'
      );
    }

    /* The stage's own bottom-right corner, expressed inside the gallery,
       so the bubble can be pinned to it. Measured rather than derived:
       the stage is absolutely positioned from a stack of custom
       properties, and reproducing that arithmetic in a second place is
       how the header link ended up in the wrong spot. */
    gallery.style.setProperty(
      '--tuti-stage-bottom',
      (stageBox.bottom - galleryBox.top) + 'px'
    );
    gallery.style.setProperty(
      '--tuti-stage-right',
      (stageBox.right - galleryBox.left) + 'px'
    );
    /* The stage's width, so the bubble can be sized as a share of the
       photo rather than a fixed pixel value: the stage is one viewport
       tall and its width follows the column, so a fixed circle read
       large on a small screen and small on a big one. */
    gallery.style.setProperty('--tuti-stage-w', stageBox.width + 'px');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      measure();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  /* A shade change moves the gallery to that shade's slides, so the
     anchors are re-read after it settles. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') setTimeout(schedule, 60);
  });
})();
